export default "__VITE_ASSET__4f2980ac__"